module.exports = __webpack_public_path__ + "media/images/flags/1x1/vut-815f4211a50b427cfec9c3432b180bcd.svg";